<template>
    <div id="pageDashboard">
        <v-container fluid grid-list-xl>
            <v-layout row wrap>
                <v-flex pb-0 xs12>
                    <filter-row></filter-row>
                </v-flex>

                <v-flex sm12 xs12 pt-0>
                    <v-layout row wrap>
                        <v-flex sm12 xs12 md6 xs6>
                            <card-linear-statistic
                                :total="estimatedCommission"
                                :reachedAmount="confirmedCommission"
                                :cancelledAmount="lostCommission"
                                :lines="[{
                                    value: confirmedCommission,
                                    tooltip: 'Contratos Pagos ao Cliente',
                                    title: 'Confirmadas',
                                    color: '#4caf50'
                                },
                                {
                                    value: lostCommission,
                                    tooltip: 'Contratos Estornados',
                                    title: 'Estornadas',
                                    color: '#f08354'
                                },
                                {
                                    value: voidedCommission,
                                    tooltip: 'Contratos Rejeitados (clientes inválidos para o produto)',
                                    title: 'Rejeitadas',
                                    color: '#f44336'
                                },
                                {
                                    value: unconfirmedCommission,
                                    tooltip: 'Contratos ainda em andamento',
                                    title: 'Em andamento',
                                    color: '#2962ff'
                                }]"
                                color="blue accent-4"
                                icon="fas fa-hand-holding-usd"
                                title="Comissões"
                                caption="Geradas"
                            >
                            </card-linear-statistic>
                        </v-flex>
                        <v-flex sm12 xs12 md6 xs6>
                            <card-statistic                                
                                :reachedAmount="balance"
                                :linearStatistic="false"
                                :todayBalance="todayBalance"
                                description="Saldo referente as comissões conciliadas."
                                :waitingApproval="waitingApprovalCommission"
                                :waitingConciliation="waitingConciliationCommission"
                                toPage="/wallet"
                                color="green accent-4"
                                icon="fas fa-money-bill-wave"
                                title="Carteira"
                                caption="saldo"                                
                            >
                            </card-statistic>    
                        </v-flex>
                    </v-layout>
                </v-flex>

                <!--SECOND LINE-->
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                            :title="uniqueDownloads | fmtFixedInt"
                            color="yellow darken-4"
                            dense
                            icon="fas fa-download"
                            sub-title="Cliques Únicos/Downloads"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                            :title="signUpClients | fmtFixedInt"
                            color="indigo"
                            dense
                            icon="fas fa-user-plus"
                            sub-title="Cadastros Iniciados"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                            :title="signUpApproved | fmtFixedInt"
                            color="blue darken-2"
                            dense
                            icon="fas fa-check-double"
                            sub-title="Cadastros Concluídos"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="">
                    <mini-statistic
                            :title="clientWithProduction | fmtFixedInt"
                            color="green darken-1"
                            dense
                            icon="fas fa-user"
                            sub-title="Clientes com Produção"
                    >
                    </mini-statistic>
                </v-flex>

                <!--THIRD LINE-->
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                            :title="requestContracts | fmtFixedInt"
                            color="yellow darken-4"
                            dense
                            icon="fas fa-file-signature"
                            sub-title="Propostas Solicitadas"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                            :title="inAnalysisContracts | fmtFixedInt"
                            color="indigo"
                            dense
                            icon="fas fa-file-alt"
                            sub-title="Contratos em Andamento"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12>
                    <mini-statistic
                            :title="concludedContracts | fmtFixedInt"
                            color="blue darken-2"
                            dense
                            icon="fas fa-file-invoice-dollar"
                            sub-title="Contratos Concluídos"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="">
                    <mini-statistic
                            :title="deniedContracts | fmtFixedInt"
                            color="red darken-1"
                            dense
                            icon="fas fa-ban"
                            sub-title="Contratos Rejeitados"
                    >
                    </mini-statistic>
                </v-flex>

                <v-flex sm12 xs12 mb-3>
                    <div style="width: 100%; height: 300px; color: #000; background-color: #FFF; border-radius: 10px; overflow: hidden; padding: 20px;">
                        <apexchart
                                ref="clicksAndSignUpChart"
                                width="100%"
                                height="100%"
                                type="bar"
                                :options="chartOptions"
                                :series="series">
                        </apexchart>
                    </div>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 v-if="isMaster">
                    <mini-statistic
                            :title="totalAffiliates | fmtFixedInt"
                            color="yellow darken-4"
                            dense
                            icon="fas fa-users"
                            sub-title="Total de Afiliados"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 v-if="isMaster">
                    <mini-statistic
                            :title="newAffiliates | fmtFixedInt"
                            color="indigo"
                            dense
                            icon="fas fa-user-plus"
                            sub-title="Novos Afiliados"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 v-if="isMaster">
                    <mini-statistic
                            :title="affiliatesWithLeads | fmtFixedInt"
                            color="blue darken-2"
                            dense
                            icon="fas fa-project-diagram"
                            sub-title="Afiliados com Leads"
                    >
                    </mini-statistic>
                </v-flex>
                <v-flex lg3 mt-2 pt-0 sm6 xs12 class="" v-if="isMaster">
                    <mini-statistic
                            :title="affiliatesWithResult | fmtFixedInt"
                            color="green darken-1"
                            dense
                            icon="fas fa-funnel-dollar"
                            sub-title="Afiliados com Resultados"
                    >
                    </mini-statistic>
                </v-flex>

                <v-flex sm12 xs12>
                    <div style="width: 100%; height: 300px; color: #000; background-color: #FFF; border-radius: 10px; overflow: hidden; padding: 20px 20px;">
                        <apexchart
                            ref="commissions"
                            width="100%"
                            height="100%"
                            type="area"
                            :options="commissionChartOptions"
                            :series="commissionSeries">
                        </apexchart>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import PageClass from '@consigmais-team/vue-common/layout/defaultPage/pageClass';
    import MiniStatistic from '@consigmais-team/vue-common/components/widgets/statistic/MiniStatistic';
    import VWidget from '@consigmais-team/vue-common/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import BoxChart from '@consigmais-team/vue-common/components/widgets/chart/BoxChart';
    import FilterRow from '@consigmais-team/vue-common/layout/defaultPage/FilterRow';
    import { StackData, SinData, monthVisitData, campaignData, locationData } from '@/api/chart';
    import CardStatistic from '@consigmais-team/vue-common/components/widgets/statistic/CardStatistic';
    import CardLinearStatistic from '@consigmais-team/vue-common/components/widgets/statistic/CardLinearStatistic';
    import numeral from 'numeral';
    import moment from 'moment';

    const defaultChartData = [{
        name: 'Sem informações',
        value: 0
    }];

    export default PageClass.extend({
        components: {
            FilterRow,
            VWidget,
            MiniStatistic,
            BoxChart,
            CardStatistic,
            CardLinearStatistic
        },

        data () {
            return {
                loading: false,

                walletId: null,
                balance: 0,
                todayBalance: 0,

                //Parte 1
                reachedCommission: 0,
                cancelledCommission: "0",
                uniqueDownloads: 0,
                signUpClients: 0,
                signUpApproved: 0,
                clientWithProduction: 0,
                requestContracts: 0,
                inAnalysisContracts: 0,
                concludedContracts: 0,
                deniedContracts: 0,

                // COMMISSIONS
                estimatedCommission: 0,
                confirmedCommission: 0,
                lostCommission: 0,
                voidedCommission: 0,
                unconfirmedCommission: 0,
                waitingApprovalCommission: 0,
                availableCommission: 0,
                waitingConciliationCommission: 0,

                series: [{
                    name: 'Cliques',
                    data: []
                },
                    {
                        name: 'Aprovados',
                        data: []
                    }],

                chartOptions: {
                    theme: {
                        mode: 'light'
                    },
                    title: {
                        text: 'Cliques x Cadastros'
                    },
                    legend: {
                        markers: {
                            strokeColor: '#FFF',
                        }
                    },
                    chart: {
                        id: 'clicksAndSignUp',
                        zoom: {
                            enabled: false
                        },
                        toolbar: {
                            show: false
                        },
                        sparkline: {
                            enabled: false
                        },
                        locales: [{
                            'name': 'pt-br',
                            'options': {
                                'months': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                                'shortMonths': ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                                'days': ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                                'shortDays': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                                'toolbar': {
                                    'exportToSVG': 'Download SVG',
                                    'exportToPNG': 'Download PNG',
                                    'menu': 'Menu',
                                    'selection': 'Selection',
                                    'selectionZoom': 'Selection Zoom',
                                    'zoomIn': 'Zoom In',
                                    'zoomOut': 'Zoom Out',
                                    'pan': 'Panning',
                                    'reset': 'Reset Zoom'
                                }
                            }
                        }],
                        defaultLocale: 'pt-br'

                    },
                    colors: ['#3F51B5', '#43A047'],
                    dataLabels: {
                        enabled: false
                    },
                    grid: {
                        show: false,
                    },
                    yaxis: {
                        show: true
                    },
                    xaxis: {
                        categories: [],
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        tooltip: {
                            enabled: false
                        }
                    }
                },

                commissionChartOptions: {
                    theme: {
                        mode: 'light'
                    },
                    title: {
                        text: 'Comissões'
                    },
                    legend: {
                        markers: {
                            strokeColor: '#000',
                        }
                    },
                    tooltip: {
                        enabled: true
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    chart: {
                        id: 'commissions',
                        toolbar: {
                            show: false
                        },
                        sparkline: {
                            enabled: false
                        },
                        locales: [{
                            'name': 'pt-br',
                            'options': {
                                'months': ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                                'shortMonths': ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                                'days': ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                                'shortDays': ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                                'toolbar': {
                                    'exportToSVG': 'Download SVG',
                                    'exportToPNG': 'Download PNG',
                                    'menu': 'Menu',
                                    'selection': 'Selection',
                                    'selectionZoom': 'Selection Zoom',
                                    'zoomIn': 'Zoom In',
                                    'zoomOut': 'Zoom Out',
                                    'pan': 'Panning',
                                    'reset': 'Reset Zoom'
                                }
                            }
                        }],
                        defaultLocale: 'pt-br'
                    },
                    dataLabels: {
                        enabled: false
                    },
                    grid: {
                        show: false,
                    },
                    yaxis: {
                        labels: {
                            formatter: function(value) {
                                return numeral(+value).format('$ 0,0.00');
                            },
                        },
                        show: true
                    },
                    xaxis: {
                        type: 'datetime',
                        categories: [],
                        rotateAlways: false,
                        hideOverlappingLabels: true,
                        tooltip: {
                            enabled: false
                        }
                    }
                },

                commissionSeries: [
                    {
                        name: 'R$',
                        data: []
                    },
                ],


                //Parte 2
                totalAffiliates: 0,
                newAffiliates: 0,
                affiliatesWithLeads: 0,
                affiliatesWithResult: 0,

                dataFilter: {},

                byComissions: false,
                perAmountType: defaultChartData,
                perCommissionType: defaultChartData,

                commissionsList: null,
                commissionCols: [
                    {
                        dataField: 'commissionDate',
                        caption: 'Período',
                        minWidth: 150
                    },
                    {
                        dataField: 'productTypeName',
                        caption: 'Tipo de Produto',
                        minWidth: 100
                    },
                    {
                        dataField: 'covenantName',
                        caption: 'Convenio',
                        minWidth: 100
                    },
                    {
                        dataField: 'amount',
                        caption: 'Valor Contrato',
                        dataType: 'number',
                        format: {
                            type: 'currency',
                            precision: 2
                        },
                        minWidth: 90
                    },
                    {
                        dataField: 'term',
                        caption: 'Prazo',
                        dataType: 'number',
                        minWidth: 90
                    },
                    {
                        dataField: 'bankChartCode',
                        caption: 'Tabela',
                        minWidth: 90
                    },
                    {
                        dataField: 'totalCommission',
                        caption: 'Comissão',
                        dataType: 'number',
                        format: {
                            type: 'currency',
                            precision: 2
                        },
                        minWidth: 90
                    },
                ],

                color: Material,
                dataset: {
                    sinData: SinData,
                    monthVisit: monthVisitData,
                    campaign: campaignData,
                    location: locationData,
                    stackData: StackData
                }
            };
        },

        computed: {
            chartType () {
                return (this.commissions && this.commissions.length > 3) ? 'area' : 'bar';
            },
            isMaster () {
                return this.$uCan({ key: 'subAfiliados' }) === 1;
            },
        },

        methods: {
            pageFiltersChange (filters) {
                this.dataFilter = {
                    affiliateId: filters.affiliateId || null,
                    productId: filters.productId || null,
                    myLeads: filters.myLeads,
                    sumType: filters.sumType,
                    beginDate: filters.dateRange[0],
                    endDate: filters.dateRange[1],
                    campaignId: filters.campaignId || null,
                };
                this.loadData(this.dataFilter);
            },

            async loadData (filters) {

                if (!filters) {
                    let actualFilters = this.$store.getters.activePageFilters;
                    filters = {
                        affiliateId: actualFilters.affiliateId || null,
                        productId: actualFilters.productId || null,
                        myLeads: actualFilters.myLeads,
                        sumType: actualFilters.sumType,
                        beginDate: actualFilters.dateRange[0],
                        endDate: actualFilters.dateRange[1],
                        campaignId: actualFilters.campaignId || null,
                    };
                }

                let data = await this.$api.dataService.execute('dashboardAffiliate/getData', filters);

                if (data) {
                    //Parte 1
                    this.reachedCommission = data.commissionReached;
                    this.cancelledCommission = data.commissionCancelled.toString();
                    this.uniqueDownloads = parseFloat(data.uniqueDownloads);
                    this.signUpClients = parseFloat(data.signUpClients);
                    this.signUpApproved = parseFloat(data.signUpApproved);
                    this.clientWithProduction = parseFloat(data.clientWithProduction);
                    this.requestContracts = parseFloat(data.requestContracts);
                    this.inAnalysisContracts = parseFloat(data.inAnalysisContracts);
                    this.concludedContracts = parseFloat(data.concludedContracts);
                    this.deniedContracts = parseFloat(data.deniedContracts);

                    // COMMISSIONS
                    this.estimatedCommission = parseFloat(data.estimatedCommission);
                    this.confirmedCommission = parseFloat(data.confirmedCommission);
                    this.lostCommission = parseFloat(data.lostCommission);
                    this.voidedCommission = parseFloat(data.voidedCommission);
                    this.unconfirmedCommission = parseFloat(data.unconfirmedCommission);
                    this.waitingApprovalCommission = parseFloat(data.waitingApprovalCommission);
                    this.availableCommission = parseFloat(data.availableCommission);
                    this.waitingConciliationCommission = parseFloat(data.waitingConciliationCommission);

                    // this.$refs.clicksAndSignUpChart.updateOptions({xaxis: {categories: data.clicksAndSignUpChartData.date}});
                    // this.$refs.clicksAndSignUpChart.updateSeries(Object.keys(data.clicksAndSignUpChartData).map(el => Object({name: el, data: data.clicksAndSignUpChartData[el]})));

                    this.$refs.clicksAndSignUpChart.updateSeries([{
                        name: 'Cliques',
                        data: data.clicksAndSignUpChartData.clicks
                    }, {
                        name: 'Aprovados',
                        data: data.clicksAndSignUpChartData.approved
                    }]);

                    this.$refs.commissions.updateSeries([{
                        name: 'Valor',
                        data: data.commissionChartData.affiliateCommission
                    }]);
                    let clicksAndSignUpChartDates = data.clicksAndSignUpChartData.date;
                    let commissionChartDates = data.commissionChartData.date;
                    switch (filters.sumType) {
                        case 'yearly':
                            clicksAndSignUpChartDates = clicksAndSignUpChartDates.map(el => {
                                return this.$moment(el).format('YYYY');
                            });
                            commissionChartDates = commissionChartDates.map(el => {
                                return this.$moment(el).format('YYYY');
                            });
                            this.$refs.clicksAndSignUpChart.updateOptions({
                                xaxis: {
                                    categories: clicksAndSignUpChartDates,
                                    labels: {
                                        format: 'yyyy'
                                    },
                                    title: {
                                        text: 'Anos'
                                    }
                                }
                            });

                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    labels: {
                                        format: 'yyyy'
                                    },
                                    title: {
                                        text: 'Anos'
                                    }
                                }
                            });
                            break;
                        case 'monthly':
                            clicksAndSignUpChartDates = clicksAndSignUpChartDates.map(el => {
                                return this.$moment(el).format('MMM YYYY');
                            });
                            commissionChartDates = commissionChartDates.map(el => {
                                return this.$moment(el).format('MMM YYYY');
                            });
                            this.$refs.clicksAndSignUpChart.updateOptions({
                                xaxis: {
                                    categories: clicksAndSignUpChartDates,
                                    labels: {
                                        format: 'MMM yyyy'
                                    },
                                    title: {
                                        text: 'Meses'
                                    }
                                }
                            });

                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    labels: {
                                        format: 'MMM yyyy'
                                    },
                                    title: {
                                        text: 'Meses'
                                    }
                                }
                            });
                            break;
                        case 'weekly':
                            // clicksAndSignUpChartDates = clicksAndSignUpChartDates.map(el => { return this.$moment(el).format('DD/MM/YYYY') })
                            this.$refs.clicksAndSignUpChart.updateOptions({
                                xaxis: {
                                    categories: clicksAndSignUpChartDates,
                                    type: 'datetime',
                                    labels: {
                                        format: 'dd/MM/yyyy'
                                    },
                                    title: {
                                        text: 'Semanas'
                                    }
                                }
                            });

                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    type: 'datetime',
                                    labels: {
                                        format: 'dd/MM/yyyy'
                                    },
                                    title: {
                                        text: 'Semanas'
                                    }
                                }
                            });
                            break;
                        default:
                            this.$refs.clicksAndSignUpChart.updateOptions({
                                xaxis: {
                                    categories: clicksAndSignUpChartDates,
                                    type: 'datetime',
                                    labels: {
                                        format: 'dd/MM/yyyy'
                                    },
                                    title: {
                                        text: 'Dias'
                                    }
                                }
                            });

                            this.$refs.commissions.updateOptions({
                                xaxis: {
                                    categories: commissionChartDates,
                                    type: 'datetime',
                                    labels: {
                                        format: 'dd/MM/yyyy'
                                    },
                                    title: {
                                        text: 'Dias'
                                    }
                                }
                            });
                            break;
                    }

                    //Parte 2
                    this.totalAffiliates = parseFloat(data.totalAffiliates);
                    this.newAffiliates = parseFloat(data.newAffiliates);
                    this.affiliatesWithLeads = parseFloat(data.affiliatesWithLeads);
                    this.affiliatesWithResult = parseFloat(data.affiliatesWithResult);
                }
            }
        },

        async created () {
            if (!this.hasPageFilters) {
                this.createPageFilters([
                    { field: 'affiliateId' },
                    { field: 'myLeads' },
                    { field: 'productId' },
                    { field: 'sumType' },
                    { field: 'dateRange' },
                    { field: 'campaignId' }
                ]);

                // DEFAULTS FILTERS
                let endDate = this.$moment().format('YYYY-MM-DD');
                let beginDate = this.$moment().format('YYYY-MM-01');
                this.setPageFilter('affiliateId', null);
                this.setPageFilter('myLeads', false);
                this.setPageFilter('campaignId', null);
                this.setPageFilter('sumType', 'daily', 'Totalizado por Dia');
                this.setPageFilter(
                    'dateRange',
                    [
                        beginDate, endDate
                    ],
                    'Entre {0} e {1}'.format(this.$moment(beginDate).format('DD/MM/YYYY'), this.$moment(endDate).format('DD/MM/YYYY'))
                );
            }
            this.loadData();
            let myWallets = await this.$api.dataService.execute('wallet/getMyWallets', {});
            if(myWallets && myWallets.length){
                this.walletId = myWallets[0].id
                let auxBalances = await this.$api.dataService.execute('wallet/getBalance', { walletId: this.walletId });
                if(auxBalances){
                    this.balance = auxBalances.balance;
                    this.todayBalance = auxBalances.todayBalance;
                }
            }else{
                //erro
                console.log("ERRO, não achou wallet")
            }
        }
    });
</script>

<style scoped>
    #PageFooter {
        background-color: transparent !important;
        background-image: linear-gradient(180deg, rgba(0, 0, 0, .86), rgba(7, 12, 19, .93)) !important;
        color: antiquewhite;
    }

    .v-card {
        height: 100%;
    }

</style>


// WEBPACK FOOTER //
// src/pages/DashboardOld.vue